import { useSelector } from 'react-redux'

import styles from '../../search.module.scss'
import { selectSearchParametersFilterByParameter } from '@/store/selectors/search'

type MinMaxProps = {
  parameter: string
  activeFilterValue: string | number
  inactiveFilterValue: string | number
  title: string
  subtitle?: string
  className?: string
  onChange: (params: { type: 'single'; filter: string; value: string | number }) => void
}

export const Toggle = ({
  parameter,
  title,
  subtitle,
  className = '',
  activeFilterValue,
  inactiveFilterValue,
  onChange,
}: MinMaxProps) => {
  const current = useSelector(state => selectSearchParametersFilterByParameter(state, parameter))

  return (
    <div className={styles.toggle}>
      <span className={styles.text}>
        <span className={styles.title}>{title}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </span>
      <button
        data-is-selected={current === activeFilterValue}
        title={title}
        type="button"
        onClick={() => {
          onChange({
            type: 'single',
            filter: parameter,
            value: current === activeFilterValue ? inactiveFilterValue : activeFilterValue,
          })
        }}
        className={`${styles['toggle-component']} ${className}`}>
        <span className={styles['dial--wrap']}>
          <span className={styles.dial}></span>
        </span>
      </button>
    </div>
  )
}
